<script lang="ts">
  import {
    step,
    type,
    typeOption as typeSelectOption,
    book,
    location,
  } from "../../stores/BookingStore";
  import { jumpTo, sendGAEvent } from "../../helpers";

  let selectedLocation: string | null;
  let currentStep: number;
  let typeOption = "glow-room";

  let video = `/wp-content/themes/badaxe/videos/glow-room/glow-room-video-bg.mp4`;

  location.subscribe((value) => {
    selectedLocation = value.name;
  });

  step.subscribe((value) => {
    currentStep = value;
  });

  /*
   * Handlers
   */
  const onSelectGlowRoomHandler = () => {
    step.update((n) => 2);
    type.update(() => typeOption);
    typeSelectOption.update((typeOption) => "glow-room");

    book.update((obj) => {
      let u = { ...obj };
      return u;
    });

    // Dispatch custom event for process.svelte to detect
    const bookEvent = new CustomEvent("bookProcessEvent", {
      detail: {
        type: typeOption,
        showBookingModal: true,
        typeOption: "glow-room",
      },
    });
    window.dispatchEvent(bookEvent);

    jumpTo("reserve-lane");
    sendGAEvent("booking", "glow-room", "Glow Room Selected");
  };
</script>

<section class="px-4 sm:px-0">
  <div
    class="max-w-7xl mx-auto bg-black text-white flex flex-col sm:flex-row rounded-xl"
  >
    <div class="flex-1 px-8 py-12">
      <h3
        class="text-2xl sm:text-3xl uppercase font-semibold mb-4 font-helveticaneue-bold-extended"
      >
        Glow Throw Experience: $46.99/person
      </h3>
      <ul class="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-6 mb-8">
        <li class="flex items-center text-white text-lg">
          <span
            class="inline-flex items-center justify-center bg-green-500 rounded-full w-6 h-6 mr-3 flex-shrink-0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 text-white"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
          Private room for 1.5 hours
        </li>
        <li class="flex items-center text-white text-lg">
          <span
            class="inline-flex items-center justify-center bg-green-500 rounded-full w-6 h-6 mr-3 flex-shrink-0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 text-white"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
          Unique glow in the dark experience
        </li>
        <li class="flex items-center text-white text-lg">
          <span
            class="inline-flex items-center justify-center bg-green-500 rounded-full w-6 h-6 mr-3 flex-shrink-0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 text-white"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
          4-12 people
        </li>
        <li class="flex items-center text-white text-lg">
          <span
            class="inline-flex items-center justify-center bg-green-500 rounded-full w-6 h-6 mr-3 flex-shrink-0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 text-white"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
          Big Axe & Knife Throwing Included
        </li>
        <li class="flex items-center text-white text-lg">
          <span
            class="inline-flex items-center justify-center bg-green-500 rounded-full w-6 h-6 mr-3 flex-shrink-0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 text-white"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
          Limited slots available
        </li>
      </ul>
      <button
        on:click|preventDefault={onSelectGlowRoomHandler}
        class="inline-flex items-center bg-yellow-300 hover:bg-yellow-400 text-black font-extrabold py-3 px-8 rounded-full border border-black shadow-md transform transition-transform hover:scale-105 text-center mt-4"
        >Book Now</button
      >
    </div>
    <div
      class="w-full sm:w-2/5 aspect-square bg-cover bg-center rounded-br-xl rounded-bl-xl sm:rounded-tr-xl sm:rounded-br-xl relative flex-shrink-0 h-[26rem]"
    >
      <video
        src={video}
        autoplay
        loop
        muted
        playsinline
        class="w-full h-full object-cover rounded-br-xl rounded-bl-xl sm:rounded-br-xl"
      />
    </div>
  </div>
</section>

<style></style>
